/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Credits_DescriptionInputs */

const en_admin_settings_fields_initial_credits_description = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_admin_settings_fields_initial_credits_description = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Admin_Settings_Fields_Initial_Credits_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_credits_description = /** @type {((inputs?: Admin_Settings_Fields_Initial_Credits_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Credits_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_initial_credits_description(inputs)
	return zh_admin_settings_fields_initial_credits_description(inputs)
});
export { admin_settings_fields_initial_credits_description as "admin.settings.fields.initial_credits_description" }